import React, { useEffect, useState } from 'react'
import {Button, Icon, Modal} from "semantic-ui-react";
import axios from "axios";


const ForgetPasswordPopup = ({ locale }) => {
    const [openModal, setOpenModal] = useState(false);
    const [fieldValue, setFieldValue] = useState();
    useEffect(() => {
        axios.get('/api/common/terms').then(response => {
            setFieldValue(response.data.forgetPassMsg);
        }).catch(ex => console.log(ex.message));
    }, []);
    return (
        <Modal
            trigger={<a href="#" style={{marginTop: 30}} onClick={() => setOpenModal(true)}>Forgot password?</a>}
            open={openModal}
        >
            <Modal.Content>
            {fieldValue}         
            </Modal.Content>
            <Modal.Actions >
                <div style={{paddingBottom: 50}}>
                    <Button onClick={() => setOpenModal(false)} floated='right'>
                        <Icon name='remove'/> {locale._system.close}
                    </Button>
                </div>
            </Modal.Actions>
        </Modal>
    )
}
export default ForgetPasswordPopup;